<template>
    <div v-if="customer && !customer.receiptLogs.length" class="centered-page">
        <div class="centered">
            <h2>
                No receipt logs found for <b>{{ customerName }}</b>
            </h2>
        </div>
    </div>
    <CustomerReceiptLogs
        v-else-if="customer"
        :receipt-logs="receiptLogs"
        :user-type="userType"
        :exclude-available-when-zero="excludeAvailableWhenZero"
        :per-page="receiptLogsPerPage"
        @perPageUpdated="setReceiptLogsPerPage($event)"
        @changeExcludeAvailableWhenZero="changeExcludeAvailableWhenZero"
    />
    <Page404 v-else-if="loaded" message="That customer was not found" />
</template>
<script>
import { mapState, mapActions } from "vuex";
import Page404 from "src/components/NotFoundPage.vue";
import store from "./_store";
import CustomerReceiptLogs from "./_components/CustomerReceiptLogs.vue";
import { mutations } from "src/global-store.js";

export default {
    name: "CustomerReceiptLogsModule",
    components: {
        CustomerReceiptLogs,
        Page404,
    },
    data() {
        return {
            loaded: false,
            excludeAvailableWhenZero: true,
            allReceiptLogs: [],
        };
    },
    computed: {
        ...mapState("$_customer", {
            receiptLogsPerPage: (state) => state.receiptLogsPerPage,
            customer: (state) => state.selectedCustomer,
        }),
        userType() {
            return "company";
        },
        customerName() {
            return this.customer?.name || "--";
        },
        receiptLogs() {
            if (!this.customer?.receiptLogs) return [];
            if (this.excludeAvailableWhenZero) {
                return this.customer.receiptLogs.filter(
                    (receipt) => receipt.availableStock > 0,
                );
            }
            return this.customer.receiptLogs;
        },
    },
    beforeCreate() {
        this.$store.registerModule("$_customer", store);
    },
    destroyed() {
        this.$store.unregisterModule("$_customer");
    },
    async created() {
        await this.fetchCustomer({ id: this.$route.params.id });
        mutations.setNavbarTitle("Receipt Logs", this.customerName);
        this.loaded = true;
    },
    methods: {
        ...mapActions("$_customer", ["setReceiptLogsPerPage", "fetchCustomer"]),
        async changeExcludeAvailableWhenZero(value) {
            this.excludeAvailableWhenZero = value;
        },
    },
};
</script>
